import { cartierDebug } from './Debug'

const loadScrollBehaviorPolyfill = () => {
	if (!('scrollBehavior' in document.documentElement.style)) {
		import(
			/* webpackChunkName: "smoothscroll-polyfill" */
			'smoothscroll-polyfill'
		)
			.then((smoothscroll) => {
				smoothscroll.polyfill()
			})
			.catch((error) => {
				cartierDebug('error', error)
			})
	}
}

const loadFocusOptionsPolyfill = () => {
	import(
		/* webpackChunkName: "focus-options-polyfill.polyfill" */
		'focus-options-polyfill'
	).catch((error) => {
		cartierDebug('error', error)
	})
}

const requestIdleCallbackShim = () => {
	window.requestIdleCallback =
		window.requestIdleCallback ||
		function requestIdleCallback(cb) {
			const start = Date.now()
			return setTimeout(() => {
				cb({
					didTimeout: false,
					timeRemaining() {
						return Math.max(0, 50 - (Date.now() - start))
					},
				})
			}, 1)
		}

	window.cancelIdleCallback =
		window.cancelIdleCallback ||
		function cancelIdleCallback(id) {
			clearTimeout(id)
		}
}

export { loadFocusOptionsPolyfill, requestIdleCallbackShim, loadScrollBehaviorPolyfill }
